var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nh-text nh-checkbox d-inline",on:{"click":_vm.clickCheck}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.check)}}),_vm._v(" "),_c('span',{attrs:{"title":_vm.hint}},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }